import PropTypes from 'prop-types';
import React from 'react';
import { Dropdown, MultiSelectDropdown } from '@eatclubapp/ec-component-library';
import { connect } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { COLORS } from '../../ObeeTheme';

const CleanDropdown = ({
  label,
  value,
  items,
  onSelect,
  onFocus,
  onBlur,
  style,
  multiSelect,
  disabled,
  ...other
}) => {
  const styles = {
    ...style,
    outerContainer: {
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      height: '40px',
    },
    disabled: {
      color: COLORS.NIMBUS,
      backgroundColor: COLORS.LIGHT_SHADE,
    },
    label: {
      color: COLORS.SMOKE,
      marginBottom: '0',
      width: '150px',
    },
    container: {},
    dropdown: {
      // backgroundColor: '#EDEDED',
      // marginLeft: '-2px',
      border: '1px solid transparent',
      width: '100%',
      color: COLORS.CHARCOAL,
      // padding: '10px',
      borderRadius: '6px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: '16px',
      paddingRight: '40px',
      minWidth: '250px',
      lineHeight: '18px',
      transition: 'background-color 0.1s',
    },
    dropdownHover: {
      backgroundColor: COLORS.LIGHT_SHADE,
    },
    dropdownOpen: {
      border: `1px solid ${COLORS.SMOKE}`,
      borderBottom: '1px solid transparent',
      backgroundColor: COLORS.LIGHT_SHADE,
      borderRadius: '6px 6px 0 0',
    },
    menu: {
      fontSize: '16px',
      top: '36px',
    },
    dropdownArrow: {
      display: 'none',
    },
    dropdownContent: {
      // border: '1px solid transparent',
      maxWidth: '200px',
    },
    dropdownContentInner: {
      maxWidth: '100%',
      padding: '10px 14px',
      lineHeight: '18px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    inputHover: {
      backgroundColor: '#EDEDED',
    },
    placeholder: {
      color: COLORS.NIMBUS,
    },
    menuItem: {
      padding: '16px 14px',
    },
  };

  if (multiSelect) {
    return (
      <MultiSelectDropdown
        label={label}
        selectedItems={value}
        items={items}
        type='text'
        onSelect={onSelect}
        placeholder='Empty'
        onFocus={onFocus}
        onBlur={onBlur}
        style={styles}
        disabled={disabled}
        {...other}
      />
    );
  }

  return (
    <Dropdown
      label={label}
      value={value}
      items={items}
      type='text'
      onSelect={onSelect}
      placeholder='Empty'
      onFocus={onFocus}
      onBlur={onBlur}
      style={styles}
      disabled={disabled}
      {...other}
    />
  );
};

CleanDropdown.defaultProps = {
  label: '',
  value: '',
  onSelect: () => {},
  onFocus: () => {},
  onBlur: () => {},
  style: {},
  items: [],
  multiSelect: false,
  disabled: false,
};

CleanDropdown.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({})]),
  onSelect: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  style: PropTypes.shape({}),
  items: PropTypes.arrayOf(PropTypes.shape({})),
  multiSelect: PropTypes.bool,
  disabled: PropTypes.bool,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CleanDropdown);
